module.exports = __webpack_public_path__ + "static/media/auction.431f43fb.png";